import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=d9bdd044&"
import script from "./TermsConditions.vue?vue&type=script&lang=js&"
export * from "./TermsConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9bdd044')) {
      api.createRecord('d9bdd044', component.options)
    } else {
      api.reload('d9bdd044', component.options)
    }
    module.hot.accept("./TermsConditions.vue?vue&type=template&id=d9bdd044&", function () {
      api.rerender('d9bdd044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/TermsConditions.vue"
export default component.exports